class CartDrawer extends MainDrawer {
  constructor() {
    super();

    this.recommendations = document.querySelector('cart-recommendations');

    // Track drawer state to detect when it transitions from active to inactive
    this.drawer = this.querySelector('.drawer');
    this.wasDrawerActive = false;
    
    if (this.drawer) {
      // Watch for drawer--active class removal (only when transitioning from active to inactive)
      this.drawerObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const isCurrentlyActive = this.drawer.classList.contains('drawer--active');
            // Only clear if drawer was active before and is now inactive
            if (this.wasDrawerActive && !isCurrentlyActive) {
              // Drawer was closed, clear recommendations
              setTimeout(() => this.clearRecommendations(), 100);
            }
            // Update tracked state
            this.wasDrawerActive = isCurrentlyActive;
          }
        });
      });
      this.drawerObserver.observe(this.drawer, {
        attributes: true,
        attributeFilter: ['class']
      });
      
      // Initialize the tracked state
      this.wasDrawerActive = this.drawer.classList.contains('drawer--active');
    }

    this.openDrawerDebounced = debounce((event) => {
      if (!document.getElementById('CARTDRAWERCSS')) {
        this.classList.add('loading');
      }

      loadCss('cart-drawer')
        .then(() => {
          this.classList.remove('loading');
        })
        .catch((error) => {
          console.error(error);
        });

      if (this.dataset.recommendations) {
        
          console.log('load cart rec');
        loadScript('cart-recommendations').catch((error) => {
          console.error(error);
        });
      }

      this.openDrawer();
    }, 250);

    document.querySelector('#cart-icon-bubble').addEventListener('click', (e) => {
      e.preventDefault();

      this.openDrawerDebounced();
    });
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    this.openDrawerDebounced();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  openDrawer() {
    const isActive = this.drawer && this.drawer.classList.contains('drawer--active');
    if (!isActive) {
      this.previousActiveElement = this.activeElement || document.activeElement;
      if (this.previousActiveElement === document.body) {
        this.previousActiveElement = null;
      }
    }
    super.openDrawer();
  }

  closeDrawer() {
    // Clear recommendations BEFORE closing drawer to ensure they're hidden
    this.clearRecommendations();

    const elementToRestore = this.previousActiveElement || this.activeElement;

    super.closeDrawer();

    this.previousActiveElement = null;
    this.activeElement = null;

    if (elementToRestore) {
      const restoreFocus = () => {
        if (
          document.body.contains(elementToRestore) &&
          !elementToRestore.disabled &&
          elementToRestore.getAttribute('aria-disabled') !== 'true'
        ) {
          const rect = elementToRestore.getBoundingClientRect();
          const style = window.getComputedStyle(elementToRestore);
          const isVisible = rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
          if (isVisible) {
            elementToRestore.focus({ preventScroll: true });
          }
        }
      };

      const drawerContainer = this.drawer ? this.drawer.querySelector('.drawer__container') : null;
      if (drawerContainer) {
        drawerContainer.addEventListener('transitionend', () => {
          setTimeout(restoreFocus, 50);
        }, { once: true });
        // Fallback in case transitionend does not fire
        setTimeout(restoreFocus, 600);
      } else {
        setTimeout(restoreFocus, 500);
      }
    }

    // Also clear after a delay to catch any re-renders
    setTimeout(() => {
      this.clearRecommendations();
    }, 600);
  }

  customTrapFocus(elementToFocus = this) {
    this.customRemoveTrapFocus();

    const drawerElement = this.querySelector('.drawer') || this;

    this.customKeydownHandler = (event) => {
      if (event.code.toUpperCase() !== "TAB") return;

      const elements = Array.from(drawerElement.querySelectorAll(
        "summary, a[href], button:enabled:not(.modal-trigger), [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )).filter(el => {
        const rect = el.getBoundingClientRect();
        const style = window.getComputedStyle(el);
        return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
      });

      if (elements.length === 0) return;

      const first = elements[0];
      const last = elements[elements.length - 1];

      // If focus is somehow outside the cart drawer, force focus back in
      if (!drawerElement.contains(event.target)) {
        event.preventDefault();
        if (event.shiftKey) {
          last.focus();
        } else {
          first.focus();
        }
        return;
      }

      // On the last focusable element and tab forward, focus the first element.
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }

      // On the first focusable element (or the container itself) and tab backward, focus the last element.
      if ((event.target === this || event.target === drawerElement || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
    };

    document.addEventListener("keydown", this.customKeydownHandler);

    if (elementToFocus) {
      if (elementToFocus === this || elementToFocus.classList.contains('drawer') || elementToFocus.classList.contains('drawer__container')) {
        const elements = Array.from(drawerElement.querySelectorAll(
          "summary, a[href], button:enabled:not(.modal-trigger), [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )).filter(el => {
          const rect = el.getBoundingClientRect();
          const style = window.getComputedStyle(el);
          return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
        });
        if (elements.length > 0) {
          elements[0].focus();
          return;
        }
      }
      elementToFocus.focus();
    }
  }

  customRemoveTrapFocus() {
    if (this.customKeydownHandler) {
      document.removeEventListener("keydown", this.customKeydownHandler);
      this.customKeydownHandler = null;
    }
  }

  clearRecommendations() {
    // Try multiple selectors to find recommendations - search everywhere
    const drawer = this.querySelector('.drawer');
    const drawerContainer = this.querySelector('#CartDrawer') || this.querySelector('.drawer__container');
    let recommendations = this.querySelector('cart-recommendations') || 
                           drawer?.querySelector('cart-recommendations') ||
                           drawerContainer?.querySelector('cart-recommendations');
    
    // If not found in drawer, search in document (might be positioned outside)
    if (!recommendations) {
      const allRecommendations = document.querySelectorAll('cart-recommendations');
      // Find the one that's likely the cart recommendations (has data-url with product_recommendations)
      recommendations = Array.from(allRecommendations).find(el => 
        el.dataset.url && el.dataset.url.includes('product_recommendations')
      ) || allRecommendations[0];
    }
    
    if (recommendations) {
      // Destroy Splide instance if it exists
      if (recommendations.splideInstance) {
        try {
          recommendations.splideInstance.destroy();
        } catch (e) {
          console.warn('Error destroying Splide:', e);
        }
        recommendations.splideInstance = null;
      }
      
      // Also try to destroy any Splide instances on child elements and find all Splide elements
      const splideElements = recommendations.querySelectorAll('.splide');
      splideElements.forEach(el => {
        if (el.splide) {
          try {
            el.splide.destroy();
          } catch (e) {
            // Ignore errors
          }
        }
      });
      
      // Also search for Splide elements that might be siblings or outside
      const allSplides = document.querySelectorAll('.cart-recommendations .splide, cart-recommendations .splide');
      allSplides.forEach(el => {
        if (el.splide) {
          try {
            el.splide.destroy();
          } catch (e) {
            // Ignore errors
          }
        }
      });
      
      // Clear the loaded content
      recommendations.innerHTML = '';
      
      // Force hide with inline style as backup
      recommendations.style.display = 'none';
      recommendations.style.visibility = 'hidden';
      recommendations.style.opacity = '0';
      recommendations.style.height = '0';
      recommendations.style.overflow = 'hidden';
      
      // Reset observer if it exists
      if (recommendations.observer) {
        recommendations.observer.disconnect();
        delete recommendations.observer;
      }
      
      // Re-initialize observer for next time drawer opens
      recommendations.observer = new IntersectionObserver(recommendations.handleIntersection.bind(recommendations));
      recommendations.observer.observe(recommendations);
    }
  }
}
customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__container',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}
customElements.define('cart-drawer-items', CartDrawerItems);

// Intercept global trapFocus and removeTrapFocus for CartDrawer instances
const originalTrapFocus = window.trapFocus;
window.trapFocus = function(container, elementToFocus) {
  const cartDrawer = container && container.closest && container.closest('cart-drawer');
  if (cartDrawer) {
    cartDrawer.customTrapFocus(elementToFocus || container);
    return;
  }
  if (originalTrapFocus) {
    originalTrapFocus(container, elementToFocus);
  }
};

const originalRemoveTrapFocus = window.removeTrapFocus;
window.removeTrapFocus = function(elementToFocus) {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    cartDrawer.customRemoveTrapFocus();
  }
  if (originalRemoveTrapFocus) {
    originalRemoveTrapFocus(elementToFocus);
  }
};

